import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { ContentRequestFieldsFragment } from '../../../../../../../../generated/core-api/graphql-react-query';
import StyledBox from './styles';

interface RequestStateTagProps {
  request: ContentRequestFieldsFragment;
}

export default function RequestStateTag(props: RequestStateTagProps) {
  const { request } = props;
  const { t } = useTranslation('requests');
  return (
    <StyledBox
      className={clsx(request.state, 'disabled')}
    >
      {t(`states.${request.state}`)}
    </StyledBox>
  );
}
